import { ChangeDetectionStrategy, Component, ElementRef, inject, output } from '@angular/core';
import { ActivitySectionDirective, UserActivityClickTrackingDirective } from '@core';
import { PageHeaderBackSwipeConfig, PageHeaderComponent } from '@app/components/page-header/page-header.component';

@Component({
  selector: 'app-more-rewards',
  templateUrl: './rewards.component.html',
  styleUrl: './rewards.component.scss',
  imports: [
    ActivitySectionDirective,
    PageHeaderComponent,
    UserActivityClickTrackingDirective,
  ],
  host: {
    class: 'page',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RewardsComponent {

  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  protected readonly backSwipeConfig: PageHeaderBackSwipeConfig = {
    element: this.elementRef.nativeElement,
  };

  public readonly back = output();

}
